import register from '../../util/init';
import InfScr from '../../util/infscr';

function clearanceInit (container) {
  const allowCache = window.DEBUG ? false : true; // reverses true=false here
  const infscr = InfScr('.paginate .group .product-list', {
    contentSelector: '.product',
    nextSelector: '.next-page',
    autoOffset: 1500,
    allowCache: allowCache,
    beforeLoad: function () {
      // nothing here...
    },
    onLoad: function (newContent, container) {
      // possible add lazyload images?
    }
  });

  return {
    resize: (...args) => {
      infscr.resize.apply(infscr, args);
    },
    scroll: (...args) => {
      infscr.scroll.apply(infscr, args);
    }
  };
}
register('collection-clearance', clearanceInit);



// WEBPACK FOOTER //
// ./assets/j/src/collection/clearance.js